import React from 'react';
import { Sparkles, Briefcase, Eye } from 'lucide-react';
import { candidateProfile } from '../data/mock';

const iconMap = {
  1: Sparkles,
  2: Briefcase,
  3: Eye
};

const CandidateProfile = () => {
  return (
    <section id="candidates" className="py-24 lg:py-32 bg-[#faf8f5]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          {/* Left - Image/Visual */}
          <div className="relative">
            <div className="aspect-[16/9] bg-[#2c2825] relative overflow-hidden">
              <img
                src="https://customer-assets.emergentagent.com/job_private-crew-hire/artifacts/7w6xpv6u_private-jet-take-off-when-sunset-generated-ai-image_511042-1483.jpg.avif"
                alt="Private Jet HZ-ABR"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Right - Content */}
          <div>
            <span className="text-xs tracking-[0.3em] uppercase text-[#c9b896] mb-4 block">
              Our Standards
            </span>
            <h2 className="font-display text-3xl md:text-4xl lg:text-5xl text-[#2c2825] mb-8" style={{ fontWeight: 400 }}>
              Candidate Profile
            </h2>
            <div className="w-16 h-px bg-[#c9b896] mb-10" />

            <div className="space-y-8">
              {candidateProfile.map((item) => {
                const Icon = iconMap[item.id];
                return (
                  <div key={item.id} className="flex items-start gap-6">
                    <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center border border-[#e8e2d9]">
                      <Icon size={22} className="text-[#c9b896]" strokeWidth={1.5} />
                    </div>
                    <div>
                      <h3 className="font-display text-lg text-[#2c2825] mb-2" style={{ fontWeight: 500 }}>
                        {item.title}
                      </h3>
                      <p className="text-sm text-[#5a5652] leading-relaxed">
                        {item.description}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CandidateProfile;
